import React, { useMemo } from 'react'
import * as classes from './TopManagement.module.scss'
import cn from 'classnames'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'

function TopManagement({ data, lang }) {
    const nodes = data?.slides?.nodes || []
    const managers = nodes.filter((item) => item.category === 'management')

    const sectionTitle = useMemo(() => (data?.topManagement?.value ? deleteHtmlTag(data.topManagement.value, 'p') : ''), [data])

    if (!managers.length) {
        return null
    }

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                <SectionTitle className={classes.SectionTitle} title={sectionTitle || 'Top Management'} lang={lang} />

                <div className={classes.Row}>
                    {managers.map((item, index) => (
                        <div className={classes.Card} key={index}>
                            {item.photo?.url ? (
                                <div className={classes.Photo} style={{ backgroundImage: `url(${item.photo.url})` }} />
                            ) : null}

                            <div className={classes.Info}>
                                <div className={classes.NameRow}>
                                    {item.name ? <p className={classes.Name}>{item.name}</p> : null}
                                </div>

                                {item.positions ? <p className={classes.Position}>{item.positions}</p> : null}
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}

export default TopManagement
